import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { faCheck, faTrash, faEllipsisV, faEye, faPencil, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";

import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import CustomTable from "./../../Components/CustomTable";

import "./style.css";

import Header from "../../Components/Header";
import usePagination from "../../Hooks/usePagination";
import useSearch from "../../Hooks/useSearch";
import { useDeleteCategoryMutation, useGetCategoriesQuery, useUpdateCategoryMutation } from "../../Redux/Apis/Category";
import { dateFormatter } from "../../Utils";
import CustomModal from "../../Components/CustomModal";

const SECTION_LABELS = {
  pros: 'The Pros',
  barn: 'The Barn',
  calcutta: 'Calcutta',
  greenskeeping: 'Greenskeeping',
  caddyshack: 'Caddyshack',
};

const headers = [
  {
    key: "id",
    title: "S.No",
  },
  {
    key: "name",
    title: "Name",
  },
  {
    key: "section",
    title: "Section",
  },
  {
    key: "registered",
    title: "Category Added On",
  },
  {
    key: "status",
    title: "Status",
  },
  {
    key: "actions",
    title: "",
  },
];

export const Category = () => {

  const navigate = useNavigate()
  const [changeCategoryStatus, { isLoading: isUpdating }] = useUpdateCategoryMutation();

  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState();

  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const [deleteModal, setDeleteModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const [search, debouncedSearch, onSearch] = useSearch()
  const { page, perPage, onNext, onPrevious } = usePagination()

  const { data, isFetching, refetch } = useGetCategoriesQuery({
    page,
    rowsPerPage: perPage,
    search: debouncedSearch,
    from,
    to
  });

  const [deleteCategory, { isLoading: isDeleting }] = useDeleteCategoryMutation()

  const inactiveMale = async () => {
    await changeCategoryStatus({ id: selectedCategoryId, payload: { active: false } })
    refetch()
    setSelectedCategoryId()
    setShowModal(false)
    setShowModal2(true)
  }

  const activeMale = async () => {
    await changeCategoryStatus({ id: selectedCategoryId, payload: { active: true } })
    refetch()
    setSelectedCategoryId()
    setShowModal3(false)
    setShowModal4(true)
  }

  const onDelete = async () => {
    await deleteCategory({ id: selectedCategoryId })
    refetch()
    setSelectedCategoryId()
    setDeleteModal(false)
    setConfirmDelete(true)
  }

  useEffect(() => {
    document.title = 'Landing List | Categories';
  }, []);

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <Header
                  title="Categories"
                  buttons={[{ label: `Add New Category`, variant: "primaryButton", onClick: () => navigate("/categories/add") }]}
                  search={search}
                  onSearch={onSearch}
                  nofilters
                />
                <div className="row mb-3">
                  {
                    isFetching ? <Loader /> :
                      <div className="col-12">
                        <CustomTable
                          headers={headers}
                          dateFilter={false}
                          filterSort={false}
                          perPage={true}
                          filterFrom={from}
                          setFilterFrom={setFrom}
                          filterTo={to}
                          setFilterTo={setTo}
                          length={data?.data?.length}
                          page={page}
                          rowsPerPage={perPage}
                          onNext={onNext}
                          onPrevious={onPrevious}
                          total={data?.total}
                        >
                          <tbody>
                            {data?.data?.map((item, index) => (
                              <tr key={item._id}>
                                <td>{(index + 1) + ((page - 1) * perPage)}</td>
                                <td className="text-capitalize">
                                  {item.name}
                                </td>
                                <td>
                                  <span className={`sectionBadge section-${item.section || 'pros'}`}>
                                    {SECTION_LABELS[item.section] || 'The Pros'}
                                  </span>
                                </td>
                                <td>{dateFormatter(item.createdAt)}</td>
                                <td className={item.active ? 'greenColor' : "redColor"}>{item.active ? 'Active' : "Inactive"}</td>
                                <td>
                                  <Dropdown className="tableDropdown">
                                    <Dropdown.Toggle variant="transparent" className="notButton classicToggle">
                                      <FontAwesomeIcon icon={faEllipsisV} />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu align="end" className="tableDropdownMenu">
                                      <Link to={`/categories/${item._id}`} className="tableAction"><FontAwesomeIcon icon={faEye} className="tableActionIcon" />View</Link>
                                      <Link to={`/edit-category/${item._id}`} className="tableAction"><FontAwesomeIcon icon={faPencil} className="tableActionIcon" />Edit</Link>
                                      <button onClick={() => {
                                        setSelectedCategoryId(item._id)
                                        setDeleteModal(true)
                                      }} className="tableAction"><FontAwesomeIcon icon={faTrash} className="tableActionIcon" /> Delete</button>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </CustomTable>
                      </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <CustomModal
            loading={isDeleting}
            show={deleteModal}
            close={() => { setDeleteModal(false); setSelectedCategoryId(null); }}
            action={onDelete}
            heading="Are you sure you want to delete this category?"
          />
          <CustomModal
            show={confirmDelete}
            close={() => { setConfirmDelete(false) }}
            success
            heading="Category deleted successfully"
          />

        </div>
      </DashboardLayout>
    </>
  );

};
